// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["master"], () => (__webpack_require__("./assets/js/application/main.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["master"], () => (__webpack_require__("./assets/scss/master.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
